import { Box, Breadcrumbs, Link } from '@mui/material'
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded'

const PageBreadcrumbs = ({ children, className = '' }) => (
  <Box component="div" role="presentation" className={className}>
    <Breadcrumbs
      aria-label="breadcrumb text-sm font-averta"
      className="text-primary font-semibold"
      sx={{
        '& .MuiBreadcrumbs-separator': {
          color: '#DDDDDD'
        }
      }}
      classes={{
        ol: 'flex-nowrap',
        li: 'flex-shrink-0 last:flex-1 last:overflow-hidden'
      }}
    >
      <Link underline="hover" className="flex items-center text-sm" href="/">
        <ChevronLeftRoundedIcon className="w-5 h-5 text-base mr-1" />
        Home
      </Link>
      {children}
    </Breadcrumbs>
  </Box>
)

export default PageBreadcrumbs
